import { Component, OnInit, Output,EventEmitter,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { WorkpermitService } from 'src/app/service/workpermit.service';
import { AlertController } from '@ionic/angular';
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { PhotoService } from 'src/app/service/helper/photo/photo.service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-add-signature-modal',
  templateUrl: './add-signature-modal.html',
  styleUrls: ['./add-signature-modal.scss', './add-signature-mobile.modal.scss'],
})
export class AddSignatureModal implements OnInit {
  @Input() isShowContractorInput = false;
  @Input() isShowContractorInputReadOnly = false;
  @Input() NameOfContractor;
  @Output() onUpload = new EventEmitter<any>();
  imagePreview = null;
  pushImage = null;
  msg = null;
 
  fileName=null;
  fileType=null;
  contractorValidationMessage = '';

  constructor(
    public modalController: ModalController, 
    public wpservice: WorkpermitService, 
    public alertController: AlertController,
    public photoService: PhotoService,
    protected domSanitizer: DomSanitizer
    ) 
    { }

  signUploadForm = new FormGroup({
    contractorName: new FormControl('', [Validators.required]),
  })
  ngOnInit() {
    this.pushImage = null;
    if(this.NameOfContractor){
      this.signUploadForm.controls.contractorName.setValue(this.NameOfContractor);
    }
    this.signUploadForm.get('contractorName').valueChanges.subscribe((data) => {
      this.contractorValidationMessage = '';
    })
  }

  capturePhoto() {
    this.photoService.takePicture().then(({webPath, file }) => {
      this.imagePreview = this.domSanitizer.bypassSecurityTrustUrl(webPath);
      this.fileName = file?.name;
      this.pushImage = file;
      this.fileType = file?.type;
    })
  }

  onRemoveFile() {
    this.msg = '';
    this.imagePreview = null;
    this.fileName = null;
    this.pushImage = null;
    this.fileType = null;
    console.log('remove');
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }


  uploadSignature1($event){
    this.contractorValidationMessage = '';
    this.msg = '';
    if(!$event.target.files[0] || $event.target.files[0].length == 0) {
			this.msg = 'You must select an image';
			return;
		}
    var mimeType = $event.target.files[0].type;
		if (mimeType.match(/image\/*/) == null) {
			this.msg = "Upload only PNG, JPG, JEPG signature images";
			return;
		}
    const reader = new FileReader();
    reader.readAsDataURL($event.target.files[0]);
    this.pushImage = $event.target.files[0];
    this.fileName = $event.target.files[0].name;
    this.fileType = $event.target.files[0].type;
     reader.onload = () => {
         this.imagePreview = reader.result as string;
     };
  }

  accesptSign(){
    this.contractorValidationMessage = '';
    this.msg = '';
    const name = this.signUploadForm?.controls['contractorName']?.value;
    if (!this.pushImage || this.signUploadForm.invalid && this.isShowContractorInput) {
      if (this.signUploadForm.invalid && this.isShowContractorInput) {
        this.contractorValidationMessage = 'Please enter contractor name';
      }
      if (!this.pushImage) {
        this.msg = 'You must be need to capture or select signature';
      }
      
      return;
    }

   
    let formData = new FormData();
    formData.append('file', this.pushImage);
    this.onUpload.emit({ formData, fileName: this.fileName, fileType: this.fileType, name });
    // this.wpservice.workPermitApproval(`api/contractor/WorkPermitApproval?fileName=${this.fileName}&fileType=${this.fileType}&user=${this.user}&wpNo=${this.wpNo}&signUserType=${this.signUserType}`, formData).subscribe(resp =>{
    //   this.emitEvent( resp['data'])
    //   this.dismiss();
    //   this.saveAsDraftSuccessAlert();
    // },(error) => console.log("Something went wrong",error))
  }

  // emitEvent(data){
  //   data['contractorName'] = this.signUploadForm.controls['contractorName'].value;
  //   console.log("***********************************************",this.signUploadForm.controls['contractorName'].value)
  //   console.log(data)
  //   this.wpservice.emitSignature(data);
  // }

  //Sign uploaded success alert
  async saveAsDraftSuccessAlert() {
    const alert = await this.alertController.create({
      animated:true,
      cssClass: 'saveAsDraftAlert Succuss2',
      header: '',
      message: 'Your signature has been uploaded successfully.',
      buttons: [{text: 'OK', role: 'cancel', cssClass: 'ok'}]
    });
    await alert.present();
  }

}



